module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "destinos"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "small-title-top pull-left"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "destinos-main-container",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.dubtitle1))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 pull-right cornered",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "info-container"
  }, [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "small-title",
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.state.subTitle2))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15pt"
    }
  }, [_vm._v(_vm._s(_vm.state.pTextTop))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-container",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_c('h3', [_vm._v(_vm._s(this.$store.state.activeList.footerPage.title))])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid white"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Copyright @2017 - All Rights Reserved")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 map-container",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0 pointer-events:none"
    },
    attrs: {
      "src": "https://www.google.com/maps/d/embed?mid=1uHvvRmH8YR8j0hS4uxjoAYqrw_w&hl=es",
      "width": "100%",
      "height": "750",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd890ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/destinos/destinos.vue
// module id = 145
// module chunks = 0